"use strict";

const confirmTable = document.querySelector(".p-lowerInquiryFormConfirm__bodyTable");

if (confirmTable) {
  const applyValues = () => {
    confirmTable.querySelectorAll(".cf7msm-ro").forEach((value) => {
      const isEmpty = value.textContent.trim() === "";
      // span は foundation で inline-block 固定のため hidden 属性では消えない
      const display = isEmpty ? "none" : "";
      const unit = value.nextElementSibling;

      if (value.style.display !== display) {
        value.style.display = display;
      }

      if (unit && unit.hasAttribute("data-confirm-unit")) {
        const text = isEmpty ? "" : unit.getAttribute("data-confirm-unit");

        if (unit.textContent !== text) {
          unit.textContent = text;
        }
        if (unit.style.display !== display) {
          unit.style.display = display;
        }
      }
    });
  };

  new MutationObserver(applyValues).observe(confirmTable, {
    childList: true,
    subtree: true,
    characterData: true,
  });

  applyValues();
}
